import useRedux from 'hooks/useRedux'
import { useSelector } from 'react-redux'
import { ApplicationState } from 'store'
import { CAMPANHA } from 'store/modules/backoffice/campanha/types'
import * as campanhaActions from 'store/modules/backoffice/campanha/actions'
import { BsTelephone } from 'react-icons/bs'
import InputCustom from 'components/Inputs'
import { Col, Row } from 'reactstrap'
import CustomSelect from 'components/Select'
import { SimpleTitleCard } from 'styles/global'
import { CiGlobe } from 'react-icons/ci'
import { PiGearLight } from 'react-icons/pi'
import { TimeInput } from 'components/Inputs/InputDateDropDown'
import { formatNumberValue, parseNumberInput } from 'util/masks'
const Discador = () => {
  const {
    register,
    visualizacao,
    categorias,
    perguntas,
    habilitarAmd,
    invalidsTabDiscador
  } = useSelector<ApplicationState, CAMPANHA>((state) => state.campanha)

  const { dispatch } = useRedux()

  function onNestedChange<
    T extends keyof CAMPANHA['register'],
    K extends keyof CAMPANHA['register'][T]
  >(field: T, nestedField: K, value: CAMPANHA['register'][T][K]) {
    dispatch(campanhaActions.setNestedRegisterField(field, nestedField, value))
  }

  return (
    <div className="d-flex flex-column row-gap-10 mb-5">
      <SimpleTitleCard>
        <BsTelephone className="icon" />
        Configurações de Discagem
      </SimpleTitleCard>
      <Row>
        <Col className="d-flex flex-column justify-content-end" md={6}>
          <label className="label-12">Categoria:</label>
          <CustomSelect
            options={categorias}
            placeholder={'Selecione'}
            onChange={(e) =>
              onNestedChange(
                'campanhaCrmParametrosDiscador',
                'pabxipCategoriaSaida',
                e
              )
            }
            value={register.campanhaCrmParametrosDiscador.pabxipCategoriaSaida}
            accessorLabel="nome"
            accessorValue="uuid"
            disabled={visualizacao}
          />
        </Col>
        <Col className="d-flex flex-column justify-content-end" md={6}>
          <label className="label-12">Hora Início*</label>
          <TimeInput
            value={register.campanhaCrmParametrosDiscador.horaInicio ?? 0}
            onChange={(value) =>
              onNestedChange(
                'campanhaCrmParametrosDiscador',
                'horaInicio',
                Number(value)
              )
            }
            invalid={invalidsTabDiscador.horaInicio}
            disabled={visualizacao}
            label={''}
          />
        </Col>

        <Col className="d-flex flex-column justify-content-end" md={6}>
          <label className="label-12">Hora Fim*</label>
          <TimeInput
            value={register.campanhaCrmParametrosDiscador.horaFim ?? 0}
            onChange={(value) =>
              onNestedChange(
                'campanhaCrmParametrosDiscador',
                'horaFim',
                Number(value)
              )
            }
            invalid={invalidsTabDiscador.horaFim}
            disabled={visualizacao}
            label={''}
          />
        </Col>
      </Row>
      <hr />
      <SimpleTitleCard>
        <CiGlobe className="icon" />
        Configurações de AMD
      </SimpleTitleCard>
      <Row>
        <Col className="d-flex flex-column justify-content-end" md={6}>
          <label className="label-12">Habilitar AMD</label>
          <CustomSelect
            options={habilitarAmd}
            onChange={(e) =>
              onNestedChange('campanhaCrmParametrosDiscador', 'habilitarAmd', e)
            }
            value={register.campanhaCrmParametrosDiscador.habilitarAmd}
            accessorLabel="label"
            accessorValue="value"
            disabled={visualizacao}
          />
        </Col>
      </Row>
      <hr />
      <SimpleTitleCard>
        <PiGearLight className="icon" />
        Configurações de Campanha
      </SimpleTitleCard>
      <div className="d-flex flex-column row-gap-10">
        <Row>
          <Col className="d-flex flex-column justify-content-end" md={4}>
            <label className="label-12">max discagens simultaneas</label>
            <InputCustom
              type="number"
              placeholder="Digite aqui"
              onChange={(e) =>
                onNestedChange(
                  'campanhaCrmParametrosDiscador',
                  'maxDiscagensSimultaneas',
                  parseNumberInput(e.target.value)
                )
              }
              value={formatNumberValue(
                register.campanhaCrmParametrosDiscador.maxDiscagensSimultaneas
              )}
              invalid={invalidsTabDiscador.maxDiscagensSimultaneas}
              disabled={visualizacao}
            />
          </Col>
          <Col className="d-flex flex-column justify-content-end" md={4}>
            <label className="label-12">Max de chamadas em espera</label>
            <InputCustom
              type="number"
              placeholder="Digite aqui"
              onChange={(e) =>
                onNestedChange(
                  'campanhaCrmParametrosDiscador',
                  'maxDiscagensEspera',
                  parseNumberInput(e.target.value)
                )
              }
              value={formatNumberValue(
                register.campanhaCrmParametrosDiscador.maxDiscagensEspera
              )}
              disabled={visualizacao}
              invalid={invalidsTabDiscador.maxDiscagensEspera}
            />
          </Col>
        </Row>
        <Row>
          {register.tipoCampanhaCrmId ===
            'd38a3f12-927f-4936-8eee-6552ce2ed81e' && (
            <Col className="d-flex flex-column justify-content-end" md={4}>
              <label className="label-12">Pergunta*</label>
              <CustomSelect
                options={perguntas}
                placeholder={'Selecione'}
                onChange={(e) => {
                  onNestedChange('campanhaCrmParametrosDiscador', 'pergunta', e)
                }}
                value={register.campanhaCrmParametrosDiscador?.pergunta ?? 0}
                accessorLabel="descricao"
                accessorValue="codigo"
                invalid={invalidsTabDiscador?.pergunta}
                disabled={visualizacao}
              />
            </Col>
          )}

          <Col className="d-flex flex-column justify-content-end" md={4}>
            <label className="label-12">Espera na fila</label>
            <InputCustom
              type="number"
              placeholder="Digite aqui"
              onChange={(e) =>
                onNestedChange(
                  'campanhaCrmParametrosDiscador',
                  'esperaNaFila',
                  parseNumberInput(e.target.value)
                )
              }
              value={formatNumberValue(
                register.campanhaCrmParametrosDiscador.esperaNaFila
              )}
              invalid={invalidsTabDiscador.esperaNaFila}
              disabled={visualizacao}
            />
          </Col>
          <Col className="d-flex flex-column justify-content-end" md={4}>
            <label className="label-12">Discagens por agente</label>
            <InputCustom
              type="number"
              placeholder="Digite aqui"
              onChange={(e) =>
                onNestedChange(
                  'campanhaCrmParametrosDiscador',
                  'discagemPorAgente',
                  parseNumberInput(e.target.value)
                )
              }
              value={formatNumberValue(
                register.campanhaCrmParametrosDiscador.discagemPorAgente
              )}
              invalid={invalidsTabDiscador.discagemPorAgente}
              disabled={visualizacao}
            />
          </Col>
        </Row>
      </div>
    </div>
  )
}

export default Discador
